import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all features
export const fetchFeatures = createAsyncThunk("features/fetchFeatures", async () => {
  try {
    const user = JSON.parse(localStorage.getItem("loggedUser"));
    const token = user?.token;
    const response = await axios.get(
      `${BASE_URL}/dashboard/features`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept-Language": "ar",
        },
      }
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || "Failed load data";
    return message;
  }
});

// add features
export const addFeatures = createAsyncThunk(
  "features/add",
  async (userData, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/features`,
        userData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تمت الإضافة بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في إضافة الميزة";
      return rejectWithValue(message);
    }
  }
);
// get features record
export const featuresRecord = createAsyncThunk(
  "features/featuresRecord",
  async (id, { rejectWithValue }) => {
    try {
    const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.get(`${BASE_URL}/dashboard/features/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحميل بيانات الميزة";
      return rejectWithValue(message);
    }
  }
);
// update features
export const updateFeatures = createAsyncThunk(
  "features/updateFeatures",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/features/${id}/update`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تم التحديث بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحديث الميزة";
      return rejectWithValue(message);
    }
  }
);
// delete features
export const deleteFeatures = createAsyncThunk(
  "features/deleteFeatures",
  async (id, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.delete(
        `${BASE_URL}/dashboard/features/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في حذف الميزة";
      return rejectWithValue(message);
    }
  }
);
const FeaturesSlice = createSlice({
  name: "features",
  initialState: {
    features: [],
    record: null,
    meta: null,
    isLoading: false,
    error: null,
    success: null,
    successMessage: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatures.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFeatures.fulfilled, (state, action) => {
        state.isLoading = false;
        state.meta = action.payload.meta;
        state.features = action.payload;
      })
      .addCase(fetchFeatures.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load data";
      })
      .addCase(addFeatures.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addFeatures.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addFeatures.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      })
      .addCase(featuresRecord.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(featuresRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload.data;
      })
      .addCase(featuresRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to add data";
      })
      .addCase(updateFeatures.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateFeatures.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
        state.successMessage = action.payload.message;
        // console.log('Feature updated successfully:', action.payload);
      })
      .addCase(updateFeatures.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          "Failed to update record";
      })
      .addCase(deleteFeatures.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteFeatures.fulfilled, (state, action) => {
        state.isLoading = false;

        // Remove from data array inside features
        if (state.features?.data) {
          state.features.data = state.features.data.filter(
            (record) => record.id !== action.meta.arg
          );
        }

        state.success = action.payload?.message || "Deleted successfully";
      })
      .addCase(deleteFeatures.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          action.error?.message ||
          "Failed to delete features";
      });
  },
});

export const { clearState } = FeaturesSlice.actions;
export default FeaturesSlice.reducer;
